(function () {
  document.addEventListener("click", (event) => {
    const element = event.target.closest("[data-component-modal]");

    if (!element) {
      return;
    }

    event.preventDefault();

    document.dispatchEvent(new CustomEvent(element.dataset.componentModal));
  });
})();

class ComponentModal extends Theme.Component {

  get name() {
    return this.getAttribute("name");
  }

  connectedCallback() {
    if (this.data.url) {
      this.render();
    }

    this.addDirectEvent(this.name, document, this.show);

    super.connectedCallback();
  }

  show(event) {
    this.classList.add("state--active");
  }

  hide() {
    this.classList.remove("state--active");
  }

  render() {
    fetch(this.data.url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load guide page: ${response.status}`);
        }

        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const fragment = doc.querySelector(this.data.fragment);

        if (!fragment) {
          throw new Error(`Document fragment was not found using this selector: ${this.dataset.fragment}`);
        }

        this.elements.content.insertAdjacentHTML("beforeend", fragment.innerHTML);
      });
  }
}

customElements.define("component-modal", ComponentModal);
